import { Message } from "primereact/message";
import { useHomeContext } from "../contexts/HomeContext";

export default function ProcessingAssetsBanner() {
    const homeContext = useHomeContext();

    if (!homeContext.hasProcessingAssets) {
        return null;
    }

    return (
        <Message
            severity="info"
            className="w-full mb-2 flex-none align-self-start"
            style={{ alignItems: "flex-start" }}
            text="Alguns ativos estão sendo atualizados. Os valores podem mudar em instantes — não é necessário repetir a operação."
        />
    );
}
